export type NinxlPricingVersion = 'v1' | 'v2'

/**
 * Switches both NINX Local and the public NINXL page between pricing models.
 * V1 is the UPI-first, pay-as-you-go launch model; V2 is the reserved tiered model.
 */
export const NINXL_PRICING_VERSION: NinxlPricingVersion = 'v1'
